<template>
	<div class="view">
		<div class="contact">
			<div class="grid-item contact-call">
				<div class="icon-parent">
					<img alt="call" class="icon" src="../assets/img/svg/24px/call_24px.svg" />
				</div>
				<div class="msg">
					call us
				</div>
				<div class="info">
					<div class="first">
						<div>Tel:</div>
						<div>
							(266) 22-311441<br />(266) 22-324814
						</div>
					</div>
					<div class='second'>
						<div>Cell:</div>
						<div>(266) 5888 0159</div>
					</div>
				</div>
			</div>
			<div class="grid-item contact-email">
				<div class="icon-parent">
					<img alt="mail" class="icon" src="../assets/img/svg/24px/email_24px.svg" />
				</div>
				<div class="msg">
					mail us
				</div>
				<div class="info">
					<div class="first">
						<div>email:</div>
						<div>admin@dyelec.co.ls</div>
					</div>
					<div class="second mail">
						<div>post:</div>
						<div>P/Bag A409 <br /> MASERU 100</div>
					</div>
				</div>
			</div>
			<div class="grid-item contact-visit">
				<div class="icon-parent">
					<img alt="location" class="icon" src="../assets/img/svg/24px/location_24px.svg" />
				</div>
				<div class="msg">
					visit us
				</div>
				<div class="info justify-start">
					DYELEC LESOTHO,<br />
					Consulting Building Services &amp; Electrical Engineers,<br />
					Atom Building,<br />
					Plot No: 13304-1991
				</div>
			</div>
		</div>
		<div class="quote border-radius-1">
			<div class="big-caps">"T</div>he attitude of a student,<br />
			never be too big to ask questions,<br />
			never know too much to learn something new.
		</div>
	</div>
</template>

<script>
import  emitter  from '@/emitter';
export default {
	name: 'contact',
	metaInfo: {
		title: 'Contacts',
		meta: [
			{
				property: 'og:url',
				content: 'http://www.dyelec.co.ls/contact'
			},
			{
				property: 'og:title', 
				content: 'Dyelec Lesotho | Contacts'
			},
			{
				name: 'description', 
				content: 'Contact us at Dyelec Lesotho by phone call, email, post, or come to our offices'
			},
			{
				property: 'og:description', 
				content: 'Contact us at Dyelec Lesotho by phone call, email, post, or come to our offices'
			},
			// Twitter card
			{
				name: 'twitter:card',
				content: 'Dyelec Lesotho'
			},
			{
				name: 'twitter:title',
				content: 'Dyelec Lesotho | Contacts'
			},
			{
				name: 'twitter:description',
				content: 'Contact us at Dyelec Lesotho by phone call, email, post, or come to our offices'
			}
		]
		// override the parent template and just use the above title only
		// titleTemplate: null
	},
	mounted() {
		emitter.$emit('new-page-name', 'Contact us');
	},
};
</script>

<style lang="scss" scoped>
	@import '../assets/style/main.scss';
	/* tangerine-regular - latin */
	@font-face {
		font-display: swap;
		font-family: 'Tangerine';
		font-style: normal;
		font-weight: 400;
		src: url('../assets/fonts/tangerine/tangerine-v11-latin-regular.eot'); /* IE9 Compat Modes */
		src: local('Tangerine Regular'), local('Tangerine-Regular'),
		url('../assets/fonts/tangerine/tangerine-v11-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
		url('../assets/fonts/tangerine/tangerine-v11-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
		url('../assets/fonts/tangerine/tangerine-v11-latin-regular.woff') format('woff'), /* Modern Browsers */
		url('../assets/fonts/tangerine/tangerine-v11-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
		url('../assets/fonts/tangerine/tangerine-v11-latin-regular.svg#Tangerine') format('svg'); /* Legacy iOS */
	}

		
	.view {
		background-image: url(../assets/img/jpg/banner_bg.jpg);
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;
		margin-top: -24px;
	}
	.contact {
		animation: slide-up 500ms ease-in-out both;
		z-index: -1;
		max-width: 1024px;
		align-self: center;
		margin-top: 3em;
		width: 100%;
		padding: 1em;
		display: grid;
		grid-gap: 1em;
		grid-template-columns: repeat( auto-fit, minmax(250px, 1fr) );
		grid-auto-rows: minmax(150px, auto);
		grid-auto-flow: row;
		justify-content: center;
		align-content: start;
		
		.contact-call {
			background-color: $blue;
			animation: flip-in-up 500ms 100ms ease-in-out both;
		}
		.contact-email {
			background-color: $blue;
			animation: flip-in-up 500ms 200ms ease-in-out both;
		}
		.contact-visit {
			background-color: $blue;
			animation: flip-in-up 500ms 300ms ease-in-out both;
		}

		.grid-item {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			padding: 1em;
			justify-items: center;
			color: $white;
			margin-top: 2em;
			position: relative;
			border-radius: $border-radius-2;
			box-shadow: 2px 2px 2px rgba(0,0,0,0.2);
			z-index: -1;
			@media (max-width: 544px) {
				max-width: 300px;
				width: 100%;
				margin-left: auto;
				margin-right: auto;
			}

			>.icon-parent {
				animation: flip-in-up 500ms 500ms ease-in-out both;
				display: flex;
				justify-self: center;
				align-items: center;
				justify-content: center;
				position: relative;
				padding: 1em;
				margin: 0px auto;
				background-color: $blue;
				top: -3em;
				border-radius: 50%;
				box-shadow: 3px 4px 2px rgba(0,0,0,0.2);

				>.icon {
					opacity: 1;
					width: 3em;
					height: 3em;

					@media (max-width: 813px) {
						width: 2em;
						height: 2em;
					}
				}
			}
			>.msg {
				animation: slide-up 500ms 750ms ease-in-out both;
				margin-top: -2em;
				opacity: 0.75;
				color: $white-light-tr-2;
				align-items:flex-end;
				width: 100%;
				font-size: 14px;
				display: flex;
				&::before, &::after {
					opacity: 0.2;
					margin-top: auto;
					margin-bottom: 0.5em;
					align-self: center;
					position: relative;
					height: 0em;
					border-bottom-color: $white;
					border-bottom-style: solid;
					border-bottom-width: 1px;
					flex-grow: 1;
					content: '';
				}
				&::before {
					margin-right: 0.5em;
					margin-left: 1em;
				}
				&::after {
					margin-left: 0.5em;
					margin-right: 1em;
				}
			}


			>.info {
				animation: slide-up 500ms 1000ms ease-in-out both;
				margin-top: 1em;
				font-weight: 400;
				letter-spacing: 0.9px;
				line-height: 1.6em;
				color: $white;
				padding: 0em 0.5em 0.5em 0.5em;
				width: 100%;
				>.first, .second{
					:first-child {
						width: 5ch;
						margin-right: 1em;
						text-align: right;
						color: $white-light-tr-2
					}
					:last-child {
						text-align: center;
						
					}
					>div {
						float: left;
					}
				}
				>.second {
					:first-child {
						padding-top: 1em;
					}
					:last-child {
						position: relative;
						float: none;
						overflow: hidden;
						text-align: left;
						padding-top: 1em;
						
						&:after {
							position: absolute;
							top: 0.35em;
							left: 0px;
							content: '';
							width: 33%;
							border-top-width: 1px;
							border-top-style: solid;
							border-top-color: $white-light-tr-3;
						}
					}
					&.mail {
						:first-child {
							padding-top: 0.7em;
						}
						:last-child {
							padding-top: 0.7em;
							&:after {
								top: 0px;
							}
						}
						margin-top: 0em;
						padding-top: 2.25em;
					}
					margin-top: 2.5em;
					padding-top: 1em;

					@media (max-width: 299px) {
						margin-top: 0.25em !important;
						padding-top: 3.5em !important;
					}
				}
			}
		}

		
	}
	.justify-start {
		justify-self: start;
	}
	.quote {
		animation: flip-in-up 500ms 1500ms ease-in-out both;
		transform: translate3d(0, 0, 0);
		background-color: hsla(0, 0%, 1%, 0.8);
		padding: 1em;
		font-family: 'Tangerine', cursive;;
		font-size: 1.7em;
		letter-spacing: 0.1em;
		line-height: 1.4em;
		color: $white;
		margin: 1em auto 0.5em auto;
		max-width: 36ch;
		.big-caps {
			font-size: 2.3em;
			display: inline-block;
			position: relative;
			top: 0.1em;
			left: -0.2em;
			margin: 0em -0.2em -0.35em 0em;
		}
	}
	@media screen and (max-width: 767px) {
		.contact {
			.grid-item {
				.info {
					min-height: 90px;
				}
			}

		}
	}
	@media screen and (min-width: 768px) {
		.contact {
			.grid-item {
				&::after {
					background-attachment: fixed;
				}
				.info {
					min-height: 150px;
				}
			}
		}
	}
</style>